import React, { useEffect } from 'react';
import { Link } from 'react-router';
import { BrandLogo } from './BrandLogo';
import LegalFooter from './LegalFooter';
import { isStreamCenterHost, mainScoutlyticsHomeUrl } from '../lsc/routing';

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, children }) => {
  useEffect(() => {
    document.title = `${title} | Scoutlytics`;
  }, [title]);

  const homeUrl = mainScoutlyticsHomeUrl();
  const onStreamHost =
    typeof window !== 'undefined' && isStreamCenterHost(window.location.hostname);

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-secondary-900 text-secondary-900 dark:text-white">
      <header className="border-b border-secondary-200 dark:border-secondary-700">
        <div className="container mx-auto px-4 py-4 flex items-center gap-3">
          {onStreamHost || homeUrl.startsWith('http') ? (
            <a href={homeUrl} className="inline-flex items-center gap-2">
              <BrandLogo variant="icon" className="h-9 w-9 rounded-lg" />
              <span className="font-semibold text-secondary-900 dark:text-white">Scoutlytics</span>
            </a>
          ) : (
            <Link to={homeUrl} className="inline-flex items-center gap-2">
              <BrandLogo variant="icon" className="h-9 w-9 rounded-lg" />
              <span className="font-semibold text-secondary-900 dark:text-white">Scoutlytics</span>
            </Link>
          )}
        </div>
      </header>

      <main className="flex-1 container mx-auto px-4 py-8 md:py-12 w-full max-w-3xl">
        {children}
      </main>

      <LegalFooter />
    </div>
  );
};

export default LegalPageLayout;
